<template>
  <section class="facilities container defaultSectionMargins">
    <div v-for="item in data" class="facilities__Item">
      <div class="facilities__ItemGallery">
        <FlickitySlider v-if="item.gallery?.length" :options="flickityOptions">
          <div v-for="image in item.gallery">
            <FlarePicture :src="{ 1920: { src: image, width: 720, height: 520, size: 'both', crop: 'fill' } }" width="720" height="520" :alt="image.alt" />
          </div>
        </FlickitySlider>
      </div>

      <div class="facilities__ItemContent">
        <h3 v-text="item.title" />
        <div v-html="item.overview" />
        <Button v-if="item.cta_text" secondary medium @click="openModal(item)">{{ item.cta_text }}</Button>
      </div>
    </div>
  </section>

  <Modal v-if="dialogs.infos" v-model="dialogs.infos" @close="closeModal" class="facilities__Modal">
    <h3 v-text="modalContent.title" />
    <FlickitySlider v-if="modalContent.gallery?.length" class="facilities__ModalSlider" :options="flickityOptions">
      <Flare v-for="image in modalContent.gallery" :srcset="image" size="both" width="790" height="520" crop="fill" gravity="faces" :alt="image" />
    </FlickitySlider>

    <div class="facilities__ModalContent" :class="{ 'fullWidth': !modalContent.contact.title && !modalContent.hours.title && !modalContent.note }">
      <div class="facilities__ModalDescription" v-html="modalContent.description" />
      <div class="facilities__ModalDetails">
        <div v-if="modalContent.contact.title" class="facilities__ModalContactDetails">
          <h4 v-text="modalContent.contact.title" />
          <a v-if="modalContent.contact.phone" :href="`tel:${modalContent.contact.phone}`">{{ modalContent.contact.phone }}</a>
          <a v-if="modalContent.contact.email" :href="`mailto:${modalContent.contact.email}`">{{ modalContent.contact.email }}</a>
        </div>
        <div v-if="modalContent.hours.title">
          <h4 v-text="modalContent.hours.title" />
          <ul v-if="modalContent.hours.table.rows.length" class="facilities__ModalTable">
            <li v-for="row in modalContent.hours.table.rows">
              <span v-text="row.column1" />
              <span v-text="row.column2" />
            </li>
          </ul>
        </div>
        <p v-if="modalContent.note" v-text="modalContent.note" />
      </div>
    </div>
  </Modal>
</template>

<script setup>
  defineProps({
    data: {}
  });
  const modalContent = ref(null);

  const dialogs = reactive({
    infos: false,
  });
  const { open } = useModal(dialogs);

  const flickityOptions = {
    pageDots: false,
    contain: true,
  };

  function openModal(item) {
    modalContent.value = item;
    open('infos')
  }

  function closeModal() {
    modalContent.value = null;
  }
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_facilities.scss');
</style>